export default __webpack_public_path__ + "static/media/tiktok-icon.c1be775c.svg";